import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function FinalCTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-slate-900 py-24 lg:py-32 relative overflow-hidden" data-id="element-160">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-tiq-purple/10 rounded-full blur-[150px]" data-id="element-161" />

      {/* Grid pattern */}
      <div className="absolute inset-0 opacity-[0.03]" data-id="element-162">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-163">
          <defs data-id="element-164">
            <pattern id="ctaGrid" width="48" height="48" patternUnits="userSpaceOnUse" data-id="element-165">
              <path d="M 48 0 L 0 0 0 48" fill="none" stroke="white" strokeWidth="0.5" data-id="element-166" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#ctaGrid)" data-id="element-167" />
        </svg>
      </div>

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-169">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-6" data-id="element-170">
            Measure Readiness Before It Becomes a Risk
          </h2>

          <p className="text-lg md:text-xl text-slate-300 leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-171">
            TalentIQ helps organizations understand whether their teams are
            prepared to execute when it matters most.
          </p>

          <p className="text-lg md:text-xl text-slate-300 leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-172">
            Start with a readiness assessment and see where capability gaps may
            exist before operations begin.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8" data-id="element-173">
            <a href="https://form.typeform.com/to/XVTziLCj" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-tiq-purple hover:bg-violet-500 text-white font-semibold rounded-lg transition-colors duration-200 text-lg shadow-lg shadow-tiq-purple/20" data-id="element-174">
              Book a Readiness Assessment
              <ArrowRightIcon className="w-5 h-5" data-id="element-175" />
            </a>
            <a href="https://calendly.com/hello-talentiqtech/enterprisedemo" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-8 py-4 border border-tiq-purple/40 text-tiq-blue hover:bg-tiq-purple/10 font-semibold rounded-lg transition-colors duration-200 text-lg" data-id="element-176">
              Book Your Readiness Index Preview
            </a>
          </div>

          <p className="text-sm text-slate-500" data-id="element-177">
            Join the early access list for readiness intelligence updates.
          </p>
        </motion.div>
      </div>
    </section>;
}